import { Component } from '@angular/core';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { WRONG_SUBDOMAIN } from '../../app.config';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './notfound.component.html',
  styleUrl: './notfound.component.css',
})
export class NotfoundComponent {
  WRONG_SUBDOMAIN = WRONG_SUBDOMAIN;
}
